import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, MapPin } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { images } from "../data/images";

const Footer = () => {
    const { t } = useLanguage();

    return (
        <footer
            data-testid="site-footer"
            className="bg-[var(--sodeco-surface)] border-t border-[var(--sodeco-border)] mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <div className="flex items-center gap-4 mb-6">
                        <span
                            className="relative inline-flex items-center justify-center w-12 h-12 rounded-full overflow-hidden ring-2 ring-[var(--sodeco-yellow)] ring-offset-2 ring-offset-[var(--sodeco-surface)]"
                            aria-hidden
                        >
                            {images.logoMark ? (
                                <img
                                    src={images.logoMark}
                                    alt="SODECO"
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <span
                                    className="w-full h-full flex items-center justify-center font-serif text-base font-semibold"
                                    style={{ background: "var(--sodeco-yellow)", color: "var(--sodeco-ink)" }}
                                >
                                    S
                                </span>
                            )}
                        </span>
                        <span className="font-serif text-3xl">SODECO</span>
                    </div>
                    <p className="text-[var(--sodeco-muted)] max-w-md leading-relaxed">
                        {t.footer.tagline}
                    </p>
                </div>

                <div className="md:col-span-3">
                    <h4 className="text-xs uppercase tracking-[0.2em] mb-5 text-[var(--sodeco-muted)]">
                        {t.footer.explore}
                    </h4>
                    <ul className="space-y-3">
                        <li>
                            <Link
                                to="/"
                                data-testid="footer-home-link"
                                className="hover:text-[var(--sodeco-yellow-deep)] transition-colors"
                            >
                                {t.nav.home}
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/missions"
                                data-testid="footer-missions-link"
                                className="hover:text-[var(--sodeco-yellow-deep)] transition-colors"
                            >
                                {t.nav.missions}
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/contact"
                                data-testid="footer-contact-link"
                                className="hover:text-[var(--sodeco-yellow-deep)] transition-colors"
                            >
                                {t.nav.contact}
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <h4 className="text-xs uppercase tracking-[0.2em] mb-5 text-[var(--sodeco-muted)]">
                        {t.footer.connect}
                    </h4>
                    <div className="flex items-center gap-4 mb-6">
                        <a
                            href="https://www.instagram.com/octavioarizanunez/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="social-instagram"
                            className="w-10 h-10 flex items-center justify-center rounded-full border border-[var(--sodeco-border)] hover:bg-[var(--sodeco-yellow)] hover:border-[var(--sodeco-yellow)] transition-all"
                            aria-label="Instagram"
                        >
                            <Instagram size={16} />
                        </a>
                        <a
                            href="https://www.facebook.com/octavio.ariza"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="social-facebook"
                            className="w-10 h-10 flex items-center justify-center rounded-full border border-[var(--sodeco-border)] hover:bg-[var(--sodeco-yellow)] hover:border-[var(--sodeco-yellow)] transition-all"
                            aria-label="Facebook"
                        >
                            <Facebook size={16} />
                        </a>
                        <a
                            href="https://youtube.com/@sodeco-r8n?si=PffwEkTsSa9AKW5C"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="social-youtube"
                            className="w-10 h-10 flex items-center justify-center rounded-full border border-[var(--sodeco-border)] hover:bg-[var(--sodeco-yellow)] hover:border-[var(--sodeco-yellow)] transition-all"
                            aria-label="YouTube"
                        >
                            <Youtube size={16} />
                        </a>
                    </div>
                    <ul className="space-y-2 text-sm text-[var(--sodeco-muted)]">
                        <li className="flex items-center gap-2">
                            <Mail size={14} /> sodecofundacioncristiana@gmail.com
                        </li>
                        <li className="flex items-center gap-2">
                            <MapPin size={14} /> Dominican Republic  · United States · Spain
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-[var(--sodeco-border)]">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[var(--sodeco-muted)]">
                    <span data-testid="footer-legal">{t.footer.legal}</span>
                    <span className="tracking-[0.25em] uppercase">Solidarity · Development · Community</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
